module.exports = __webpack_public_path__ + "media/images/Decline2-blue-5b0142163657815edf1e35b2c9582cc9.svg";